import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Table, TableModule  } from "primeng/table";
import { ConstantService } from 'app/Shared/Services/constant-service';
import { CommonModule } from '@angular/common';
import {TooltipModule} from "primeng/tooltip";


@Component({
    selector: 'app-turbo-table',
    templateUrl: './turbo-table.component.html',
    imports: [TableModule, CommonModule, TooltipModule],
    providers: [],
    styleUrls: ['./turbo-table.component.scss']
})
export class TurboTableComponent implements OnInit {
  @ViewChild(('dt')) dt!: Table;
  @Input('GridColumns') GridColumns!: any[];
  @Input('Dataset') Dataset: any = [];
  @Input('TotalRecords') totalRecords: any;
  @Input('SymbolFilter') SymbolFilter: any;
  tbldatamsg="No records found";
  selectedColumns!: any[];
  constructor(
    public constantService:ConstantService) { }

  ngOnInit() {
    this.selectedColumns = this.GridColumns;
    this.totalRecords = this.Dataset.length;
  }
}